<template>
  <Skeleton
    v-if="breadcrumbs.length && !isMounted"
    :height="skeletonHeight"
    width="100px"
    class="margin-bottom-xs"
  />
  <Breadcrumb
    v-show="breadcrumbs.length && isMounted"
    :model="breadcrumbs"
    :last-item-clickable="true"
    aria-label="breadcrumb"
    class="breadcrumbs"
  />
</template>

<script setup>
import { useMounted } from '@vueuse/core';
import Breadcrumb from '@atomic-ui/breadcrumb';
import Skeleton from '@common-vue/atomic-ui/src/components/skeleton';
import { useBrand } from '@composables/useBrand';
import { useBreadcrumbs } from '../composables/useBreadcrumbs';

const { breadcrumbs } = useBreadcrumbs();
const { isMcom } = useBrand();

const skeletonHeight = isMcom ? '18px' : '17px';
const isMounted = useMounted();
</script>

<style lang="scss" brand="mcom" scoped>
.breadcrumbs {
  &:deep(.p-menuitem-text) {
    line-height: 18px;
  }
}
</style>

<style lang="scss" brand="bcom" scoped>
.breadcrumbs {
  &:deep(.p-menuitem-text) {
    line-height: 17px;
  }
}
</style>
